"use client";

import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MapPin } from "lucide-react";
import { useEffect, useRef, useState } from "react";
export default function UbicacionesYMapa() {
  const [isVisible1, setIsVisible1] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const ref1 = useRef<HTMLDivElement>(null);
  const ref2 = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = entry.target.getAttribute("data-index");
          if (index === "0") setIsVisible1(true);
          if (index === "1") setIsVisible2(true);
        }
      });
    }, {
      threshold: 0.2
    });
    if (ref1.current) observer.observe(ref1.current);
    if (ref2.current) observer.observe(ref2.current);
    return () => observer.disconnect();
  }, []);
  const locations = [{
    title: "Ceremonia",
    venueName: "Concatedral de San Julián",
    address: "Rúa Igrexa, 104, 15402 Ferrol, A Coruña",
    image: "https://dondeseacabaelmar.com/wp-content/uploads/2026/02/iglesia-sanjulian-1.jpg?v=utugwx9nlxm",
    directionsUrl: "https://www.google.com/maps/search/?api=1&query=Concatedral+de+San+Juli%C3%A1n+de+Ferrol"
  }, {
    title: "Banquete",
    venueName: "Pazo de Vilaboa",
    address: "Rúa Souto, 2, 15174 Culleredo, A Coruña",
    image: "https://dondeseacabaelmar.com/wp-content/uploads/2026/02/foto-principal_1_3705-172286436964479.jpeg?v=xad523esbhr",
    directionsUrl: "https://www.google.com/maps/search/?api=1&query=Pazo+de+Vilaboa"
  }];
  return <section id="ubicaciones-y-mapa" className="bg-light-background py-[var(--space-4xl)] overflow-hidden">
      <div className="container">
        <div className="text-center mb-[var(--space-3xl)]">
          <h2 className="font-display text-[2.125rem] font-semibold leading-[1.3] text-foreground-light mb-[var(--space-md)]">
            Ubicaciones de la celebración
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Encuentra fácilmente cómo llegar a la ceremonia y el banquete.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[var(--space-3xl)] max-w-6xl mx-auto">
          {locations.map((location, i) => <div key={i} data-index={i} ref={i === 0 ? ref1 : ref2} className={`transition-all duration-[var(--duration-medium)] ${(i === 0 ? isVisible1 : isVisible2) ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="border-[length:var(--border-thick)] border-border shadow-medium hover:shadow-strong hover:-translate-y-2 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] overflow-hidden p-[var(--space-lg)]">

                {}
                <h3 className="font-display text-2xl sm:text-3xl font-semibold text-foreground-light text-center mb-[var(--space-md)]">
                  {location.venueName}
                </h3>

                {}
                <div className="relative w-full h-[260px] sm:h-[300px] md:h-[340px] border-[length:var(--border-md)] border-accent rounded-[var(--radius-lg)] overflow-hidden mb-[var(--space-lg)] group">
                  <img src={location.image} alt={location.venueName} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>

                {}
                <CardContent className="p-0">
                  <div className="mb-[var(--space-md)]">
                    <h4 className="font-display text-lg font-semibold text-muted-foreground mb-[var(--space-xs)] flex items-center gap-[var(--space-sm)]">
                      <MapPin className="size-5 text-muted-foreground" />
                      {location.title}
                    </h4>

                    <p className="text-muted-foreground text-sm">
                      {location.address}
                    </p>
                  </div>
                </CardContent>

                {}
                <CardFooter className="p-0 pt-[var(--space-md)]">
                  <Button asChild className="w-full bg-primary text-foreground-primary hover:bg-primary-hover active:bg-primary-active shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                    <Link to={location.directionsUrl} newTab>
                      Cómo llegar
                    </Link>
                  </Button>
                </CardFooter>

              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}